import { getRandomDecimal } from "./helperFunctions";
const hydrateQueryParams = (rule = {}, attributes) => {
  let conditionDataType;
  if (rule.dataFrameConditionQuery) {
    // Look in the dataFrameAttribute.attributes array instead of the main attributes array
    const dataFrameAttributes = rule.dataFrameAttribute?.attributes || [];
    conditionDataType = dataFrameAttributes.find(a => a.conditionAttribute === rule.conditionAttribute)?.conditionAttributeType;
  } else {
    const foundAttribute = attributes.find(
      att => (att.conditionAttribute || att.key) === rule.conditionAttribute
    ) || {
      conditionAttributeType: 'String'
    };
    conditionDataType = foundAttribute?.dataType || foundAttribute?.conditionAttributeType || 'String';
  }
  return {
    conditionDataType: conditionDataType,
    ...rule
  };
};

const mapRule = (rule, attributes = []) => {
  let ruleBody = {
    id: getRandomDecimal(),
    schemaType: rule.schemaType,
    ...(rule.dataFrameConditionQuery && {
      dataFrameConditionData: {
        dataFrameAttribute: rule.dataFrameConditionData?.dataFrameAttribute,
        dataFrameSizeQuery: rule.dataFrameConditionData?.dataFrameSizeQuery,
      },
      dataFrameConditionQuery: rule.dataFrameConditionQuery,
      dataFrameAttribute: {
        attributes: [...(attributes.find(
          att => (att.key || att.conditionAttribute) === rule.dataFrameConditionData?.dataFrameAttribute
        )?.subAttribute?.attributes || []), { displayName: 'Dataframe Count', conditionAttribute: 'dataframeCount', conditionAttributeType: "Integer" }]
      }
    }),
    condition: rule.condition,
    conditionAttribute: rule.conditionAttribute,
    conditionValue: Array.isArray(rule.conditionValue)
      ? rule.conditionValue
      : typeof rule.conditionValue === 'boolean'
        ? [rule.conditionValue.toString()]
        : [rule.conditionValue],
    ...(rule.dateComparisonOptions && {
      dateComparisonOptions: Array.isArray(rule.dateComparisonOptions) 
        ? rule.dateComparisonOptions.map(option => ({
            dynamicDate: option.dynamicDate,
            dateFormatType: option.dateFormatType,
            dynamicField: option.dynamicField,
            dateOffset: option.dateOffset,
            staticDateField: option.staticDateField
          }))
        : rule.dateComparisonOptions
    })
  };
  if (rule.conditionAttributeType) {
    return { conditionDataType: rule.conditionAttributeType, ...ruleBody };
  } else {
    return hydrateQueryParams(ruleBody, attributes);
  }
};

// helpers to reshape and hydrate data
const mapRuleBody = (query, attributes = []) => {
  return query.map(r => {
    let rule = Object.assign({}, r);
    if (rule?.conditionOperator) {
      rule = {
        ...rule,
        id: getRandomDecimal()
      };
      rule.subConditionExpressions = mapRuleBody(
        rule.subConditionExpressions,
        attributes
      );
      return rule;
    } else {
      return mapRule(rule, attributes);
    }
  });
};

export const mapExpressionFromResposne = (exp = {}, attributes = []) => {
  let expression = Object.assign({}, exp);
  if (Array.isArray(expression)) {
    expression = {
      conditionOperator: 'AND',
      subConditionExpressions: expression
    };
  }

  if (expression?.conditionOperator) {
    expression.subConditionExpressions = mapRuleBody(
      expression.subConditionExpressions,
      attributes
    );
  } else if (Object.keys(expression).length > 0) {
    expression = {
      conditionOperator: 'OR',
      subConditionExpressions: [mapRule(expression, attributes)]
    };
  }
  return expression;
};

const flattenRuleForRequest = (rule = {}) => {
  return {
    height: rule?.height,
    depth: rule?.depth,
    schemaType: rule.schemaType,
    ...(rule.dataFrameConditionQuery && {
      dataFrameConditionData: {
        dataFrameAttribute: rule.dataFrameConditionData?.dataFrameAttribute,
        dataFrameSizeQuery: rule.dataFrameConditionData?.dataFrameSizeQuery,
      },
      dataFrameConditionQuery: rule.dataFrameConditionQuery
    }),
    conditionAttribute: rule.conditionAttribute,
    conditionAttributeType: rule.conditionDataType,
    condition: rule.condition,
    conditionValue:
      Array.isArray(rule.conditionValue) && rule.conditionValue.length === 1
        ? rule.conditionDataType === 'Boolean'
          ? rule.conditionValue[0] === 'true'
          : rule.conditionValue[0]
        : rule.conditionValue,
    ...(rule.conditionDataType === 'Date' && rule.dateComparisonOptions && {
      dateComparisonOptions: Array.isArray(rule.dateComparisonOptions)
        ? rule.dateComparisonOptions
        : Object.keys(rule.dateComparisonOptions).map(key => rule.dateComparisonOptions[key])
    })
  };
};

const flattenTemplateRulesForRequest = (query = []) => {
  return query.map(templateRule => {
    let rule = Object.assign({}, templateRule);
    if (rule?.conditionOperator) {
      rule.subConditionExpressions = flattenTemplateRulesForRequest(
        rule?.subConditionExpressions
      );
      return rule;
    } else {
      return flattenRuleForRequest(rule);
    }
  });
};

export const flattenExpressionForRequest = (expression = {}) => {
  let tempExpression = expression?.subConditionExpressions || [];

  if (tempExpression.length === 0) return undefined;

  if (
    tempExpression.length === 1 &&
    !tempExpression[0].hasOwnProperty('conditionOperator')
  ) {
    expression = flattenRuleForRequest({
      ...tempExpression[0],
      depth: 0
    });
  } else {
    expression.subConditionExpressions = flattenTemplateRulesForRequest(
      tempExpression
    );
  }
  return expression;
};
